import Logger from './logger';
import Emitter from './emitter';
import Receiver from './receiver';
import on from './on';

const debug = (...args) => Logger.info(...args);
const auth = cb => cb(true);

export function getToken() {
    const isGuestAccess = sessionStorage.getItem('guest_access');
    if (isGuestAccess) return sessionStorage.getItem('token');

    return localStorage.getItem('token');
}

export default class Socket extends Emitter {
    constructor(ctrl, nsp, opts = {}) {
        super();

        this.connected = false;
        this.ctrl = ctrl;
        this.auth = opts.auth || auth;
        this.receiver = new Receiver(opts);
        this.ctrl.autoConnect && this.open();
    }
    get disconnected() {
        return !this.connected;
    }
    subEvents() {
        if (this.subs) return;

        const ctrl = this.ctrl;
        this.subs = [
            on(ctrl, 'open', this.onopen.bind(this)),
            on(ctrl, 'data', this.ondata.bind(this)),
            on(ctrl, 'error', this.onerror.bind(this)),
            on(ctrl, 'close', this.onclose.bind(this))
        ];
    }
    get active() {
        return !!this.subs;
    }
    connect() {
        if (this.connected) return this;

        this.subEvents();
        if (!this.ctrl['_reconnecting']) this.ctrl.open(); // ensure open
        if ('open' === this.ctrl._readyState) this.onopen();
        return this;
    }
    refresh() {
        this.disconnect();

        const url = new URL(this.ctrl.uri);
        const params = new URLSearchParams(url.search);
        params.set('token', getToken());

        url.search = params.toString();

        this.ctrl.uri = url.toString();

        this.connect();
    }
    open() {
        return this.connect();
    }
    send(...args) {
        this.ctrl.engine.send(...args);
        return this;
    }
    onopen() {
        debug('connecting');
        if (typeof this.auth === 'function') {
            this.auth(valid => {
                if (valid) {
                    this.onconnect();
                } else {
                    this.emitReserved('connect_error', new Error('verification'));
                }
            });
        } else {
            this.onconnect();
        }
    }
    ondata(event) {
        const { reason } = event;
        if (!reason) return;
        debug(`receiving (${reason})`, event);
        try {
            this.receiver.emit(reason, event);
        } catch (err) {
            this.emitReserved('error', err);
        }
    }
    onerror(err) {
        if (!this.connected) {
            this.emitReserved('connect_error', err);
        }
    }
    onclose(reason = '') {
        if (!this.connected) return this;
        debug(`closing socket (${reason})`);
        this.connected = false;
        this.emitReserved('disconnect', reason);
    }
    onconnect() {
        debug('socket connected');
        this.connected = true;
        this.emitReserved('connect');
    }
    ondisconnect() {
        debug('got disconnect socket');
        this.onclose('client disconnect');
        this.destroy();
    }
    destroy() {
        if (this.subs) {
            this.subs.forEach(subDestroy => subDestroy());
            this.subs = undefined;
        }
        this.ctrl['destroy'](this);
        this.receiver['destroy']();
    }
    disconnect() {
        if (!this.connected) return this;
        this.emitReserved('disconnecting');
        this.ondisconnect();
        return this;
    }
    close() {
        return this.disconnect();
    }
}
